import { useEffect } from 'react';
import { db } from '../firebase/config';
import { setDoc, doc } from 'firebase/firestore';

const AddVendors = () => {
  useEffect(() => {
    const vendorData = {
      alternateContact: 8667658303,
      contact: 8608462631,
      email: "",
      isRegistered: true,
      latitude: 12.9988631,
      longitude: 80.271761,
      name: "Venkat Mutton center",
      placeAddress: "Naganallur, Tamil Nadu, India",
      placeId: "ChIJ2QauKuNnUjoRkfE8ECuLTYQ",
      placePhotoUrl: "https://firebasestorage.googleapis.com/v0/b/area51india.firebasestorage.app/o/place_photos%2FChIJ2QauKuNnUjoRkfE8ECuLTYQ.jpg?alt=media&token=7a43d4e1-6877-4f7d-9611-fd1767e5dfc4",
      products: {
        country_chicken: {
          date: "2025-07-21T18:09:35.000Z",
          imageUrl: "https://firebasestorage.googleapis.com/v0/b/area51india.firebasestorage.app/o/product_images%2Fcountry_chicken.png?alt=media&token=02b4e684-f9e7-4547-8ad7-3c75fac64d25",
          price: 500,
          units: "Kg",
          shopName: "venkat Mutton center"
        },
        mutton: {
          date: "2025-07-21T18:09:35.000Z",
          imageUrl: "https://firebasestorage.googleapis.com/v0/b/area51india.firebasestorage.app/o/product_images%2Fcountry_chicken.png?alt=media&token=02b4e684-f9e7-4547-8ad7-3c75fac64d25",
          price: 800,
          units: "Kg",
          shopName: "venkat Mutton center"
        }
      }
    };

    const uploadData = async () => {
      try {
        await setDoc(doc(db, 'area51_vendors', '3693693693'), vendorData);
        console.log('✅ Vendor object stored as document fields!');
      } catch (error) {
        console.error('❌ Error uploading data:', error);
      }
    };

    uploadData();
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Uploading vendor object into Firestore document...</h2>
    </div>
  );
};

export default AddVendors;
